import React from "react"

const serializers = {
  types: {},
}

export default serializers
